import convert from "geo-coordinates-parser";
import { ILocation } from "./models/ILocation";

/**
 * Parse a string in any of these formats and returns lat/lon in decimal degrees
 * 40.123, -74.123
 * 40.123° N 74.123° W
 * 40° 7´ 22.8" N 74° 7´ 22.8" W
 * 40° 7.38’ , -74° 7.38’
 * N40°7’22.8, W74°7’22.8"
 * 40°7’22.8"N, 74°7’22.8"W
 * 40 7 22.8, -74 7 22.8
 * 40.123 -74.123
 * 40.123°,-74.123°
 * 144442800, -266842800
 * 40.123N74.123W
 * 4007.38N7407.38W
 * 40°7’22.8"N, 74°7’22.8"W
 * 400722.8N740722.8W
 * N 40 7.38 W 74 7.38
 * 40:7:23N,74:7:23W
 * 40:7:22.8N 74:7:22.8W
 * 40°7’23"N 74°7’23"W
 * 40°7’23" -74°7’23"
 * 40d 7’ 23" N 74d 7’ 23" W
 * 40.123N 74.123W
 * 40° 7.38, -74° 7.38
 */
export function parseGeoCoordinates(str: string): ILocation | undefined {
    try {
        const converted = convert(str);
        return {
            lat: converted.decimalLatitude,
            lon: converted.decimalLongitude,
        };
    } catch {
        return undefined;
    }
}
